import { FilterSectionAfterSearch } from "./FilterSectionAfterSearch";
import FilterSection from "./controller/FilterSection";
import AddIcon from "@mui/icons-material/Add";

const {
  CRow,
  CCol,
  CLabel,
  CSelect,
  CInput,
  CButton,
} = require("@coreui/react");
const { useState, useEffect } = require("react");
const { apiCallResponse } = require("src/_apiConfig/apiCall");

export const CommonSearch = (props) => {
  const [itemsCollectionSeason, setItemsCollectionSeason] = useState([]);
  const [itemsTenderNo, setItemsTenderNo] = useState([]);

  useEffect(() => {
    getTenderCollectionSeasonDrop();
    getTenderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isClear]);

  const getTenderCollectionSeasonDrop = async () => {
    await apiCallResponse(`Tender/GetTenderCollectionSeason`, "GET").then(
      (res) => {
        debugger;
        if (res.success) setItemsCollectionSeason(res.data);
        else setItemsCollectionSeason([]);
      }
    );
  };

  const getTenderDetails = async (tenderCollectionSeasonSearch = "") => {
    let filter = "";

    if (
      tenderCollectionSeasonSearch !== "" &&
      tenderCollectionSeasonSearch !== undefined
    ) {
      filter =
        "&$filter=contains(collectionSeason,'" +
        tenderCollectionSeasonSearch +
        "')";
    }
    await apiCallResponse(`Tender?$orderBy=tenderNo%20desc${filter}`).then(
      (res) => {
        if (res.success) setItemsTenderNo(res.data);
        else setItemsTenderNo([]);
      }
    );
  };

  const handleChangeTenderCollectionSeason = (e) => {
    const value = e.target.value;
    props.updateSearch(e, "tenderNo", "");
    setItemsTenderNo([]);
    getTenderDetails(value);
  };
  return (
    <div>
      <CRow>
        <SCSelect
          labelname="Collection Season"
          name="collectionSeason"
          value={props.search.collectionSeason}
          onChange={handleChangeTenderCollectionSeason}
          items={itemsCollectionSeason.map((item, key) => ({
            value: item.collectionSeason,
            label: item.collectionSeason,
          }))}
        />
        <SCSelect
          labelname="Tender Number"
          name="tenderNo"
          value={props.search.tenderNo}
          onChange={props.updateSearch}
          items={itemsTenderNo
            .sort((a, b) => b.tenderNo.localeCompare(a.tenderNo))
            .map((item, key) => ({
              value: item.tenderNo,
              label: item.tenderNo,
            }))}
        />

        {props.isCompanyNameDisplay === true && (
          <SCInput
            label={
              props.CompanyNameLabel
                ? props.CompanyNameLabel
                : "Company Name : "
            }
            name={"companyName"}
            value={props.search.companyName}
            onChange={props.updateSearch}
          />
        )}
        {props.isEmailAddressDisplay === true && (
          <SCInput
            label={"Email Address :"}
            name={"emailAddress"}
            value={props.search.emailAddress}
            onChange={props.updateSearch}
          />
        )}
        {props.isLotNumberDisplay === true && (
          <SCInput
            label={"Lot Number : "}
            name={"lotNo"}
            value={props.search.lotNo}
            onChange={props.updateSearch}
          />
        )}
        {props.extraControl}
      </CRow>
      <CRow>
        {props.isAfterSearchDataDisplay &&
        props.isAfterSearchDataDisplay === true ? (
          <FilterSectionAfterSearch
            isDisabledSearchClear={props.isDisabledSearchClear}
            search={props.searchButton}
            clear={props.clearSearch}
            itemPerPage={props.itemPerPage}
            onChangePage={props.onChangePage}
            isExporting={props.isExporting}
            isDisabledExport={props.isDisabledExport}
            ExportToExcel={props.ExportToExcel}
            isExportToExcelDisplay={props.isExportToExcelDisplay}
            extraSearchControl={props.extraSearchControl}
            isAfterSearchDataDisplay={props.isAfterSearchDataDisplay}
            isDisplayItemPageDropDown={props.isDisplayItemPageDropDown}
          />
        ) : (
          <FilterSection
            isDisabledSearchClear={props.isDisabledSearchClear}
            search={props.searchButton}
            clear={props.clearSearch}
            itemPerPage={props.itemPerPage}
            onChangePage={props.onChangePage}
            isExporting={props.isExporting}
            isDisabledExport={props.isDisabledExport}
            ExportToExcel={props.ExportToExcel}
            isExportToExcelDisplay={props.isExportToExcelDisplay}
            extraSearchControl={props.extraSearchControl}
          />
        )}
      </CRow>{" "}
    </div>
  );
};

export const CommonSearchExtra = (props) => {
  return (
    <div>
      <CRow>{props.extraControl}</CRow>
      <CRow>
        {/* <FilterSection
          isDisabledSearchClear={props.isDisabledSearchClear}
          search={props.searchButton}
          clear={props.clearSearchButton}
          itemPerPage={props.itemPerPage}
          onChangePage={props.onChangePage}
          isExporting={props.isExporting}
          isDisabledExport={props.isDisabledExport}
          ExportToExcel={props.ExportToExcel}
          isExportToExcelDisplay={props.isExportToExcelDisplay}
          extraSearchControl={props.extraSearchControl}
        /> */}

        {props.isAfterSearchDataDisplay &&
        props.isAfterSearchDataDisplay === true ? (
          <FilterSectionAfterSearch
            isDisabledSearchClear={props.isDisabledSearchClear}
            search={props.searchButton}
            clear={props.clearSearchButton}
            itemPerPage={props.itemPerPage}
            onChangePage={props.onChangePage}
            isExporting={props.isExporting}
            isDisabledExport={props.isDisabledExport}
            ExportToExcel={props.ExportToExcel}
            isExportToExcelDisplay={props.isExportToExcelDisplay}
            extraSearchControl={props.extraSearchControl}
            isAfterSearchDataDisplay={props.isAfterSearchDataDisplay}
            isDisplayItemPageDropDown={props.isDisplayItemPageDropDown}
          />
        ) : (
          <FilterSection
            isDisabledSearchClear={props.isDisabledSearchClear}
            search={props.searchButton}
            clear={props.clearSearchButton}
            itemPerPage={props.itemPerPage}
            onChangePage={props.onChangePage}
            isExporting={props.isExporting}
            isDisabledExport={props.isDisabledExport}
            ExportToExcel={props.ExportToExcel}
            isExportToExcelDisplay={props.isExportToExcelDisplay}
            extraSearchControl={props.extraSearchControl}
          />
        )}
      </CRow>{" "}
    </div>
  );
};

// Search Controller Input
export const SCInput = (props) => {
  return (
    <CCol xl={3} sm={6}>
      <CLabel>{props.label}</CLabel>
      <CInput
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange} // Corrected the typo here
      />
    </CCol>
  );
};

export const SCSelect = (props) => {
  return (
    <CCol xl={3} sm={6} className={props.CColClassName}>
      <CLabel>
        {props.labelname}
        {props.isRequired === true && (
          <>
            &nbsp;<span className="customRedFont">*</span>&nbsp;
          </>
        )}
        :{" "}
      </CLabel>
      <CSelect
        required
        aria-label="Default select example"
        id={props.id === "" ? props.name : props.id}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      >
        {props.isSelectShow !== false && (
          <option value="">Select {props.labelname}</option>
        )}
        {props.items?.map((item, key) => (
          <option key={key} value={item.value}>
            {item.label}
          </option>
        ))}
      </CSelect>
    </CCol>
  );
};
export const SCDate = (props) => {
  return (
    <CCol xl={3} sm={6}>
      <CLabel>{props.label} :</CLabel>
      <CInput
        type="date"
        placeholder=""
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        min={props.minDate !== "" ? props.minDate : undefined}
        max={props.maxDate !== "" ? props.maxDate : undefined}
      />
    </CCol>
  );
};
export const updateSearchStatus = (
  setSearch,
  search,
  e,
  name = "",
  value = ""
) => {
  if (name !== "") {
    setSearch({
      ...search,
      [e.target.name]: e.target.value,
      [name]: value,
    });
  } else {
    setSearch({
      ...search,
      [e.target.name]: e.target.value,
    });
  }
};

export const SCAddButton = (props) => {
  return (
    <CButton className="btn btn-success ml-3 plus-icon-area" to={props.tourl}>
      <AddIcon />
    </CButton>
  );
};
export const SCAddButtonClick = (props) => {
  return (
    <CButton
      className="btn btn-success ml-3 plus-icon-area"
      onClick={props.onClick}
    >
      props.lable
    </CButton>
  );
};
